import React, { Component } from 'react';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import { Cascader, Input, Button, Select, DatePicker } from 'antd';
import SearchRetrieve from '../../common/SearchRetrieve.new';
import moment from 'moment';

const Option = Select.Option;
const { MonthPicker, RangePicker } = DatePicker;

class Filter extends Component {

    state = {
        researchProductTypeList: [],
        byStageList: [],
        businessList: [],
        areaList: [],
        typeList: [],
        BusinessOpportunityList: [],
    }

    componentDidMount(){
        this.queryConfigWithChildByType();
        this.queryBusiness();
        this.loadTypeConfigureList();
        this.queryBasicConfigureByType();
    }

    //研究产品类型选项
    queryConfigWithChildByType = () => {
        dictCache.getDict('CONFIG_WITH_CHILD_RESEARCH_PRODUCT_TYPE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.evaluate.queryConfigWithChildByType,
                data: { type: 'RESEARCH_PRODUCT_TYPE' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { list = [] } = res;
            const newList = list.map(el => ({
                value: el.evaluateConfigureId,
                code: el.code,
                label: el.configureValue,
                children: el.childList.length ? el.childList.map(childData => ({
                    value: childData.evaluateConfigureId,
                    label: childData.configureValue,
                })) : undefined,
            }));
            this.setState({ researchProductTypeList: newList });
        });
    }

    //临床分期选项
    loadByStageList = (researchProductTypeId) => {
        const { researchProductTypeList } = this.state;
        let investigationMedicineType = '';
        researchProductTypeList.map(el => {
            if (el.value == researchProductTypeId[0]) {
                investigationMedicineType = el.code;
            }
        });
        if (investigationMedicineType) {
            const options = {
                method: 'POST',
                url: API_URL.common.queryInvestigationByStageByMedicine,
                data: { investigationMedicineType },
                dataType: 'json',
                doneResult: res => {
                    this.setState({ byStageList: res.data });
                }
            }
            $.sendRequest(options);
        } else {
            this.setState({ byStageList: [] });
        }
    }

    //获取业务线选项
    queryBusiness = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ businessList: res.typeConfigureList || [] });
        });
    }

    //获取项目领域、项目分类选项
    loadTypeConfigureList = () => {
        dictCache.getDict('TYPE_CONFIGURE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.typeConfigureList,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({
                areaList: res.areaList,
                typeList: res.typeList,
            });
        });
    }

   //业务机会状态查询
    queryBasicConfigureByType = () => {
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryBasicConfigureByType,
            data: { type: 'BusinessOpportunity' },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    BusinessOpportunityList: res.datas,
                });
            }
        }
        $.sendRequest(options)
    }

    handleChange = (value, key) => {
        const { params } = this.props;
        params[key] = value;
        switch (key) {
            case 'researchProductTypeId':
                params.byStageId = undefined;
                this.loadByStageList(value);
                break;
            case 'investigationAreaId':
                params.diseaseId = undefined;
                break;
        }
        this.props.onChange(params, key);
    }

    searchRetrieveChange = (option, key) => {
        const { params } = this.props;
        params[`${key}Id`] = option.value;
        params[`${key}Name`] = option.text;
        this.props.onChange(params, key);
    }

    reset = () => {
        this.props.onChange({researchProductTypeId: undefined});
        this.props.search();
    }

    disabledDate = (current, key) => {
        const { params: { beginYearMonthStr, endYearMonthStr } } = this.props;
        return key === 'endYearMonthStr'? current < moment(beginYearMonthStr) : current > moment(endYearMonthStr);
    }

    render() {
        const { params, search, dataExport } = this.props;
        const { 
            evaluateCode,
            businessOpportunityNum,
            pmUserName,
            talUserName,
            bdUserName,
            baUserName,
            evaluateSerialNumber,
            sponsorCompanyName,
            submissionTarget,
            researchProductTypeId,
            byStageId,
            investigationAreaId,
            diseaseName,
            evaluateStatus,
            businessOpportunityStatusShow,
        } = params;
        const { researchProductTypeList, byStageList, businessList, areaList, typeList, BusinessOpportunityList } = this.state;
        const byStageOption = byStageList.map(el => <Option value={el.investigationByStageId}>{el.investigationByStageName}</Option>); //临床分期
        const businessOption = businessList.filter(el => el.groupId == 1).map(el => <Option value={el.typeConfigureId}>{el.typeValue}</Option>);  //业务线
        const areaOption = areaList.map(el => <Option value={el.investigationAreaId}>{el.investigationAreaName}</Option>); //治疗领域
        const typeOption = typeList.map(el => <Option value={el.typeConfigureId}>{el.typeValue}</Option>);  //项目分类
        const BusinessOpportunityOption = BusinessOpportunityList.map(el => <Option value={el.configureValue} title={el.configureValue}>{el.configureValue}</Option>);  //业务机会状态
        
        return (
            <div className="search-bar" style={{ marginBottom: 10 }}>
                
                <div className="search-item">
                    <label htmlFor="" className="ui-label">临床评估单号</label>
                    <Input
                        style={{ width: 120 }}
                        placeholder="请输入"
                        value={evaluateCode}
                        onChange={e => this.handleChange(e.target.value, 'evaluateCode')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">业务机会编号</label>
                    <Input
                        style={{ width: 120 }}
                        placeholder="请输入"
                        value={businessOpportunityNum}
                        onChange={e => this.handleChange(e.target.value, 'businessOpportunityNum')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">PM</label>
                    <SearchRetrieve
                        keyword='keyword'
                        style={{width: 160}}
                        placeholder='输入名称检索'
                        params={{limit: 20}}
                        url={API_URL.investigation.queryUserByKey}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user'}}
                        value={pmUserName}
                        onChange={value => this.searchRetrieveChange(value, 'pmUser')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">领域leader</label>
                    <SearchRetrieve
                        keyword='keyword'
                        style={{width: 160}}
                        placeholder='输入名称检索'
                        params={{limit: 20}}
                        url={API_URL.user.queryLeaderList}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user'}}
                        value={talUserName}
                        onChange={value => this.searchRetrieveChange(value, 'talUser')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">BD</label>
                    <SearchRetrieve
                        keyword='keyword'
                        style={{width: 160}}
                        placeholder='输入名称检索'
                        params={{limit: 20}}
                        url={API_URL.investigation.queryUserByKey}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user'}}
                        value={bdUserName}
                        onChange={value => this.searchRetrieveChange(value, 'bdUser')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">BA</label>
                    <SearchRetrieve
                        keyword='keyword'
                        style={{width: 160}}
                        placeholder='输入名称检索'
                        params={{limit: 20}}
                        url={API_URL.investigation.queryUserByKey}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user'}}
                        value={baUserName}
                        onChange={value => this.searchRetrieveChange(value, 'baUser')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">方案编号</label>
                    <Input
                        style={{ width: 120 }}
                        placeholder="请输入"
                        value={evaluateSerialNumber}
                        onChange={e => this.handleChange(e.target.value, 'evaluateSerialNumber')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">申办方</label>
                    <SearchRetrieve
                        keyword='customerCompanyName'
                        style={{width: 160}}
                        placeholder='输入名称检索'
                        params={{limit: 20, natureName: '申办方'}}
                        url={API_URL.investigation.queryCustomerCompanyByName}
                        config={{ id: 'customerCompanyId', name: 'customerCompanyName'}}
                        value={sponsorCompanyName}
                        onChange={value => this.searchRetrieveChange(value, 'sponsorCompany')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">报价对象</label>
                    <Input
                        style={{ width: 120 }}
                        placeholder="请输入"
                        value={submissionTarget}
                        onChange={e => this.handleChange(e.target.value, 'submissionTarget')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">研究产品类型</label>
                    <Cascader
                        style={{ width: 120 }}
                        allowClear
                        placeholder="请选择"
                        options={researchProductTypeList}
                        value={researchProductTypeId}
                        onChange={value => this.handleChange(value, 'researchProductTypeId')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">临床分期</label>
                    <Select
                        style={{width: 120}}
                        allowClear
                        placeholder='请选择'
                        value={byStageId}
                        onChange={value => this.handleChange(value, 'byStageId')}
                    >
                        {byStageOption}
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">治疗领域</label>
                    <Select
                        style={{width: 160}}
                        placeholder='输入名称检索'
                        allowClear
                        showSearch
                        filterOption= {(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        value={investigationAreaId}
                        onChange={value => this.handleChange(value, 'investigationAreaId')}
                    >
                        {areaOption}
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">适应症</label>
                    <SearchRetrieve
                        keyword='keyword'
                        style={{width: 160}}
                        placeholder='输入名称检索'
                        params={{limit: 20, investigationAreaId: investigationAreaId ? investigationAreaId : undefined}}
                        url={API_URL.common.queryAllDisease}
                        config={{ id: 'diseaseId', name: 'diseaseName'}}
                        value={diseaseName}
                        onChange={value => this.searchRetrieveChange(value, 'disease')}
                    />
                </div>
                
                <div className="search-item">
                    <label htmlFor="" className="ui-label">报价状态</label>
                    <Select
                        style={{width: 180}}
                        allowClear
                        placeholder='请选择'
                        value={evaluateStatus}
                        onChange={value => this.handleChange(value, 'evaluateStatus')}
                    >
                        <Option value={'NEW_EVALUATE'}>{'待PM评估'}</Option>
                        <Option value={'CLINICAL_RETURN_EVALUATION'}>{'临床退回评估单'}</Option>
                        <Option value={'CLINICAL_NON_ACCEPTANCE_EVALUATION'}>{'临床不承接评估单'}</Option>
                        <Option value={'CONFIRM'}>{'PM确认评估单'}</Option>
                        <Option value={'REFUSE'}>{'领域leader/BO拒绝评估单'}</Option>
                        <Option value={'SUBMIT'}>{'领域leader/BO提交评估单'}</Option>
                        <Option value={'REPULSE'}>{'商务反馈评估建议'}</Option>
                        <Option value={'STATE_FOR_APPROVAL'}>{'总价审批中'}</Option>
                        <Option value={'STATE_FOR_RESTART_APPROVAL'}>{'总价重新申请中'}</Option>
                        <Option value={'STATE_APPROVAL_REFUSED'}>{'总价审批不通过'}</Option>
                        <Option value={'STATE_APPROVED'}>{'总价审批已通过'}</Option>
                        <Option value={'STATE_CONFIRM'}>{'总价已确认'}</Option>
                        <Option value={'STATE_PUBLISHED'}>{'报价已发布'}</Option>
                        <Option value={'STATE_PUBLISHED_REEVALUATE_CONFIRM'}>{'报价已发布（待二次评估确认）'}</Option>
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">业务机会状态</label>
                    <Select
                        style={{width: 160}}
                        allowClear
                        placeholder='请选择'
                        value={businessOpportunityStatusShow}
                        onChange={value => this.handleChange(value, 'businessOpportunityStatusShow')}
                    >
                        {BusinessOpportunityOption}
                    </Select>
                </div>
                <div className="search-item">
                    <Button key="search" type="primary" onClick={search}>搜索</Button>
                    <Button key="export" type="primary" onClick={dataExport}>导出</Button>
                    <Button key="reset" type="primary" onClick={this.reset}>重置</Button>
                </div>
            </div>
        )
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/businessOffer/businessOfferRecord/Filter.js